import { TitleId } from '@domgen/dgx-fe-common';
import { FormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { CLPApplianceDetailsPersonDetailsFormField } from './clp-appliance-details-person-form-field.enum';

export interface CLPApplianceDetailsPersonDetailsFormValue {
  [CLPApplianceDetailsPersonDetailsFormField.Address]: FormOverrideAddress;
  [CLPApplianceDetailsPersonDetailsFormField.FirstName]: string | null;
  [CLPApplianceDetailsPersonDetailsFormField.Surname]: string | null;
  [CLPApplianceDetailsPersonDetailsFormField.Title]: TitleId | null;
}
